import { Map } from 'immutable';

import {
  CONCLUDE_CONTRACT_SIGNATURE_REQUEST,
  CONCLUDE_CONTRACT_SIGNATURE_FAILURE,
  CONCLUDE_CONTRACT_SIGNATURE_SUCCESS,
} from './action';

const initialState = Map({
  type: '',
  payload: [],
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === CONCLUDE_CONTRACT_SIGNATURE_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], []);
  }

  if (type === CONCLUDE_CONTRACT_SIGNATURE_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === CONCLUDE_CONTRACT_SIGNATURE_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
